import React from 'react'
import styled from 'styled-components'
import { spacing } from 'frontend_core/dist/styles/variables'
import AccountTemplate from 'components/templates/AccountTemplate'
import BusinessSignUpBox from 'components/organisms/BusinessSignUpBox'
import LoginBox from 'components/organisms/LoginBox'
import SocialSignUpForm from 'components/organisms/SocialSignUpForm'
import SignUpForm from 'containers/organisms/SignUpForm'
import LoadingView from 'components/atoms/LoadingView'
import { APP_LINK_URL_SIGNUP } from 'hooks/useAppLink'

class SignUpPage extends React.Component {
  render() {
    const { referrer } = this.props
    return (
      <AccountTemplate
        title={this.props.title}
        description={this.props.description}
        linkCanonical={this.props.linkCanonical}
        currentUser={this.props.currentUser}
        breadcrumbs={this.props.breadcrumbs}
        config={this.props.config}
        image={this.props.image}
        isSignUpPage
      >
        {this.props.isLoading && <LoadingView />}
        <div className="page__even lp-page__padding">
          <div className="page__col1">
            <div className="signup-head">
              <h1 className="page-title">{i18n.t('page.account.l_00001')}</h1>
            </div>
            {referrer && (
              <p className="signup-notice">
                これまでご好評いただいたお友だち招待キャンペーンは2023年6月5日をもって終了いたしました。
              </p>
            )}
            <LoginBox
              {...this.props}
              showAppLink
              appLinkUrl={APP_LINK_URL_SIGNUP}
              appLinkEventName="App Install Button Clicked"
              appLinkEventProperties={{ page_name: 'signup' }}
            />
            <div className="signup-box">
              <div className="row">
                <div className="col-xs-12">
                  <h2 className="signup-box__title">
                    {i18n.t('page.account.l_00002')}
                  </h2>
                  <SocialSignUpForm {...this.props} />
                </div>
              </div>
            </div>
            <div className="signup-box">
              <div className="row">
                <div className="col-xs-12">
                  <h2 className="signup-box__title">
                    {i18n.t('page.account.l_00013')}
                  </h2>
                  <div className="signup-box__wrapper-form">
                    <div className="row signup-box__md-top">
                      <SignUpForm {...this.props} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <BusinessSignUpBox />
          </div>
        </div>
      </AccountTemplate>
    )
  }
}
export default SignUpPage

const StyledAboutSpaceMarketWrapper = styled.div`
  margin-top: ${spacing.medium_3}px;
`
